(function($) {
  //
  // Object Fit Polyfill
  //
  objectFitImages()
  objectFitVideos()

  //
  // AOS
  //
  AOS.init({
    once: true
  })

  //
  // Jarallax
  //
  jarallax( document.querySelectorAll('.jarallax'), {
    disableParallax: function() {
      return window.innerWidth < 768;
    }
  } )

  //
  // Fancykbox
  //
  $.fancybox.defaults.buttons = ['share', 'thumbs', 'close']

  //
  // Site
  //
  if (window.Site === undefined) {
    window.Site = {};
  }
  
  if (window.Site.Currency === undefined) {
    window.Site.Currency = 'THB';
  }
  
  if (window.Site.Language === undefined) {
    window.Site.Language = 'EN';
  }
})(jQuery);